import styled from 'styled-components';

const VendorPriceTierFormStyled = styled.form``;

export { VendorPriceTierFormStyled };
